import {Component, computed, effect, inject, OnInit} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {
  IonAccordion,
  IonAccordionGroup, IonButton,
  IonCard,
  IonCol,
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonRow,
  IonSegment, IonSegmentButton
} from "@ionic/angular/standalone";
import {FooterComponent} from "../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {addIcons} from "ionicons";
import {cashOutline, homeOutline,peopleOutline, ribbonOutline, rocketOutline, gridOutline, libraryOutline} from "ionicons/icons";
import {LanguageService} from "../../core/language.service";
import {pages} from "../../configs/config";
import {ColumnContentComponent} from '../components/column-content/column-content.component';
import {ServiceContentComponent} from './service-content/service-content.component';
import {ContentSwiperSliderComponent} from './content-swiper-slider/content-swiper-slider.component';
import {B2bSectionComponent} from '../components/b2b-section/b2b-section.component';
import {FormsModule} from '@angular/forms';
import {Meta, Title} from '@angular/platform-browser';
import {FaqComponent} from './faq/faq.component';
import {OurServicesService} from './our-services.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-our-services',
    templateUrl: './our-services.component.html',
    styleUrls: ['./our-services.component.scss'],
  imports: [
    HeaderComponent,
    IonContent,
    FooterComponent,
    ColumnContentComponent,
    ServiceContentComponent,
    ContentSwiperSliderComponent,
    B2bSectionComponent,
    IonRow,
    IonCol,
    IonButton,
    FormsModule,
    RouterLink,
    FaqComponent,
    TranslateModule
  ]
})
export class OurServicesComponent  implements OnInit {
  languageService: LanguageService = inject(LanguageService);
  ourServicesPage: any;
  pageService: OurServicesService = inject(OurServicesService);
  constructor() {
    addIcons({ cashOutline, homeOutline, peopleOutline, ribbonOutline, rocketOutline, gridOutline, libraryOutline });
    effect(async () => {
      if (this.languageService.lang()) {
        this.ourServicesPage = await this.languageService.loadContent(pages.services);
      }
    })
  }
  isScrolled: boolean = false;
  pageContent = computed(() => this.pageService.pageContentResource.value()?.content);
  pageImages = computed(() => this.pageService.pageContentResource.value()?.images);
  isContentLoading = this.pageService.pageContentResource.isLoading;

  leasingPage: any;
  assetPage: any;
  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {

    this.title.setTitle('Connecting Tenants & Landlords in Riyadh');

    this.meta.addTags([
      {property: 'og:title', content: 'Connecting Tenants & Landlords in Riyadh'},
      {name: 'description', content: 'At Satel, we are passionate about connecting tenants with their ideal homes and providing exceptional property management services to landlords in Riyadh. We prioritize client satisfaction and strive to build long-term relationships with both tenants and property owners.\n'},
      {property: 'og:description', content: 'At Satel, we are passionate about connecting tenants with their ideal homes and providing exceptional property management services to landlords in Riyadh. We prioritize client satisfaction and strive to build long-term relationships with both tenants and property owners.\n'},
      {property: 'og:image', content: 'https://satel.sa/assets/satel-og-image.jpg'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Connecting Tenants & Landlords in Riyadh'},
      {name: 'twitter:description', content: 'At Satel, we are passionate about connecting tenants with their ideal homes and providing exceptional property management services to landlords in Riyadh. We prioritize client satisfaction and strive to build long-term relationships with both tenants and property owners.\n'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel.sa/assets/satel-og-image.jpg'}
    ]);
    this.ourServicesPage = await this.languageService.loadContent(pages.services);
    this.leasingPage = await this.languageService.loadContent(pages.leasingAndRental);
    this.assetPage = await this.languageService.loadContent(pages.assetsAndPropertyManagement);
  }
}
